export const examTypesCollection = () => {
    return [
        { name: "Half Yearly Exam", value: "half-yearly" },
        { name: "Quarterly Exam", value: "quarterly" },
        { name: "Final Exam", value: "final" },
        { name: "Custom", value: "custom" }
    ];
}
